/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateStatusRequest = {
    status: UpdateStatusRequest.status;
    note?: string;
};
export namespace UpdateStatusRequest {
    export enum status {
        NONE = 'NONE',
        RECEIVE = 'RECEIVE',
        ORDER_SPARE = 'ORDER_SPARE',
        RECEIVE_SPARE = 'RECEIVE_SPARE',
        REPAIRING = 'REPAIRING',
        TESTING = 'TESTING',
        REPAIR_SUCCESS = 'REPAIR_SUCCESS',
        REPAIR_FAIL = 'REPAIR_FAIL',
        CANCEL = 'CANCEL',
    }
}

